var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrentLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 38,
    viewBox: "0 0 28 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14C0.5 6.54415 6.54415 0.5 14 0.5C21.4558 0.5 27.5 6.54415 27.5 14C27.5 16.8527 26.486 19.5279 25.1044 22.0025C24.0362 23.9158 22.7687 25.6763 21.6003 27.2992C21.2524 27.7824 20.9133 28.2534 20.5908 28.7127C18.283 31.9993 16.3084 34.487 15.0579 35.9958C14.5014 36.6672 13.5069 36.6651 12.9506 35.9901C11.6948 34.4665 9.70961 31.9621 7.40809 28.7111C7.12694 28.314 6.83468 27.9081 6.53609 27.4934C5.31102 25.792 3.97946 23.9427 2.87204 21.9435C1.49802 19.463 0.5 16.8024 0.5 14Z",
    fill: "#D85140",
    stroke: "#A2281F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 6,
    fill: "#A2281F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/currentLocation.bd3d6fb3f44891beca5b74d8d166bf8d.svg";
export { ForwardRef as ReactComponent };